import Seo from '@/components/public/Seo';
import HeroHome from '@/components/public/sections/HeroHome';
import QuickAccessHub from '@/components/public/sections/QuickAccessHub';
import NoticeCarousel from '@/components/public/sections/NoticeCarousel';
import UpcomingEvents from '@/components/public/sections/UpcomingEvents';
import { parishName, useSite } from '@/hooks/useSite';

type Props = {
  featuredNews: Array<{
    id: number;
    title: string;
    slug: string;
    excerpt: string | null;
    date: string | null;
    imageUrl: string | null;
  }>;
  upcomingEvents: Array<{
    id: number;
    title: string;
    description: string | null;
    location: string | null;
    startsAt: string;
    endsAt: string | null;
    imageUrl: string | null;
  }>;
};

export default function Home({ featuredNews, upcomingEvents }: Props) {
  const site = useSite();
  return (
    <>
      <Seo
        title="Início"
        description={`Descubra os serviços, eventos e a história da ${parishName(site)}.`}
      />
      <HeroHome />
      <QuickAccessHub />
      <NoticeCarousel news={featuredNews} />
      <UpcomingEvents events={upcomingEvents} />
    </>
  );
}
